<div>
  <div class="container">
    <div class="input-wrapper">
      <div class="left-section">
        <h1 class="heading">
          <span class="highlight">Attendance Solutions</span> <br />
          for Modern Schools<span class="dot">.</span>
          <img src="../../../assets/images/mall-star2.png" class="image1" />
          <img src="../../../assets/images/small-star1.png" class="image2" />
        </h1>
        <p>
          Effortless track student and staff attendance in real-time with a
          seamless, digital solution designed to keep your school running
          efficiently
        </p>
        <button (click)="goToPage()">Get Attendance App</button>
        <div *ngIf="logoUrl?.length">
          <div class="carousel-container">
            <div class="carousel-images">
              <!-- <ng-image-slider
                [imageSize]="getImgSize()"
                [autoSlide]="autoSlide"
                [infinite]="infiniteSlide"
                [showArrow]="false"
                [animationSpeed]="1"
                [images]="logoUrl"
                #gallery
              ></ng-image-slider> -->
              <div class="marquee-wrapper">
                <om-marquee [animationDuration]="'40s'">
                  <div
                    class="marquee-card"
                    *ngFor="let logo of logoUrl"
                    #OmMarqueeContent
                  >
                    <img [src]="logo.url" class="school-logos" />
                  </div>
                </om-marquee>
                <div class="marquee-gradient left"></div>
                <div class="marquee-gradient right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-section">
        <div class="image-wrapper">
          <img src="../../../assets/images/attendance-image.png" alt="image" />
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="wrapper">
    <div class="platform-container">
      <div class="box" *ngFor="let item of attendanceFeatures">
        <div class="image-container">
          <img [src]="item.imageUrl" alt="Box Image" />
        </div>
        <div class="platform-description">
          <h2>{{ item.heading }}</h2>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
    <div class="att-button">Download App Today →</div>
  </div> -->
  <div class="feature-section">
    <div class="feature-container">
      <div class="feature-text">
        <h2>
          Say Goodbye to
          <span style="color: #0066ff"
            >Attendance <br />
            Registers</span
          >
          &
          <span style="color: #0066ff">Save Paper</span>
        </h2>
        <p>
          Reduce paper usage and streamline your school's processes with our
          advanced biometric attendance system.Make Attendance Tracking
          Eco-Friendly, Efficient, and Effortless with Digital Tools
        </p>
        <a
          href="https://play.google.com/store/apps/details?id=com.inforida.godview&hl=en_IN"
          >Upgrade to Paperless Attendance →</a
        >
      </div>
      <div class="feature-image">
        <img src="../../../assets/images/attendance.png" alt="image" />
      </div>
    </div>
    <div class="feature-container">
      <div class="feature-image">
        <img src="../../../assets/images/savetime.png" alt="image" />
      </div>
      <div class="feature-text">
        <h2>
          <span style="color: #0066ff">Save time</span> on attendance <br />
          &
          <span style="color: #0066ff">Spend Where It Matters</span>
        </h2>
        <p>
          Save countless hours with our automated system that eliminates manual
          tracking. Focus on enhancing learning and Student Engagement While we
          handle Attendace seamlessly And Accurately.
        </p>
        <a
          href="https://play.google.com/store/apps/details?id=com.inforida.godview&hl=en_IN"
          >Transform Your Attendance System →</a
        >
      </div>
    </div>
    <div class="feature-container">
      <div class="feature-text">
        <h2>
          Protect Your <span style="color: #0066ff">Data</span> With
          <span style="color: #0066ff"
            >Secure <br />
            Biometric </span
          >Technology
        </h2>
        <p>
          Ensure data privacy and Security with cutting-edge face recognition
          authentication. Our biometric solution safeguards sensitive
          information and delivers precise attendance trancking with advanced
          Technology.
        </p>
        <a
          href="https://play.google.com/store/apps/details?id=com.inforida.godview&hl=en_IN"
          >Secure Your School Today →</a
        >
      </div>
      <div class="feature-image">
        <img src="../../../assets/images/biometric.png" alt="image" />
      </div>
    </div>
  </div>

  <div class="stats-container">
    <div class="stats-header">
      <img
        src="../../../assets/images/good-morning-logo.png"
        alt="good-morning-logo"
      />
      <h2>
        Schools with <span>Goood Morning</span> Attendance system has already
        saved...
      </h2>
    </div>
    <div class="stats-cards">
      <div class="stats-card" *ngFor="let card of statsData">
        <h3>{{ card.description }}</h3>
        <h2>
          {{ card.sign }}<span>{{ card.displayValue }}</span
          >{{ card.entity }}
        </h2>
      </div>
    </div>
  </div>
  <div class="app-footer-1">
    <div class="foot-right">
      <img
        src="../../../assets/images/mornign-app.png"
        alt="logo"
        class="footer-image"
      />
      <p class="foot-sub-title">
        Free, Secure Face <br />
        Paperless Attendance
      </p>
      <div class="foot-store-wrap">
        <a
          href="https://play.google.com/store/apps/details?id=com.inforida.godview&hl=en_IN"
          target="_blank"
        >
          <img src="../../../assets/images/playstore.png" />
        </a>
      </div>
    </div>
    <div class="col-4">
      <img src="../../../assets/images/student-imge.png" class="mobile-img" />
      <img src="../../../assets/images/Star.png" class="foot-star" />
    </div>
  </div>
</div>
